var $ = require('jquery');

$(function(){
  'use strict';

  $('.js-placeholder').on('focus', function(){
    $(this).parent().addClass('is-active');
  });

  $('.js-placeholder').on('blur', function(){
    $('.js-placeholder').each(function(){
      if($(this).val() == '') {
        $(this).parent().removeClass('is-active');
      }
    });
  });

  $('.js-placeholder').each(function(){
    if($(this).val() == '') {
      $(this).parent().removeClass('is-active');
    } else {
      $(this).parent().addClass('is-active');
    }
  });
});